import { Space, Typography } from "antd"
import { Flex, Icon } from "../../common"

const { Paragraph } = Typography

const TitleDescription = props => {
  const { title, description, color, icon, onClick, titleClassName, iconProps, iconOnClick, titleProps } = props
  return (
    <Flex align="center" gap={"8px"}>
      {icon && (
        <Icon
          icon={icon}
          size={iconProps?.size}
          color={iconProps?.iconColor}
          hasBackground={iconProps?.hasBackground}
          onClick={iconOnClick}
          {...iconProps}
        />
      )}
      <div>
        <Paragraph className={"mbe-0 " + titleClassName} onClick={onClick} {...titleProps}>
          {title}
        </Paragraph>
        {description && (
          <Paragraph className="mbe-0" style={{ color: color ? color : "#9d9d9d" }}>
            {description}
          </Paragraph>
        )}
      </div>
    </Flex>
  )
}

export default TitleDescription
